const hotspotWrapperEl = document.querySelector('.product-hotspot-section__wrapper')
const hotspotMediaWrapperEl = hotspotWrapperEl.querySelector('.product-hotspot-section__media-inner-wrapper')
const hotspotBtnsElList = hotspotMediaWrapperEl.querySelectorAll('.product-hotspot-section__hotspot');
const hotspotDetailsElList = hotspotWrapperEl.querySelectorAll('.product-hotspot-section__hotspot-details');

if (hotspotBtnsElList.length != 0){
    // HANDLED BUTTON CLICK EVENTS
    hotspotBtnsElList.forEach(hotspotBtn => {
    hotspotBtn.addEventListener("click", function(){
        const hotspotPinId = this.dataset.hotspotPinId
        hotspotBtnsElList.forEach(currentHotspotBtn => {
            const currentHotspotPinId = currentHotspotBtn.dataset.hotspotPinId
            if (currentHotspotPinId != hotspotPinId ){
                currentHotspotBtn.classList.contains("active") && currentHotspotBtn.classList.remove("active")
            }else{
                if (!currentHotspotBtn.classList.contains('active')) {
                    currentHotspotBtn.classList.add("active")
                }
            }
        })
        hotspotDetailsElList.forEach(hotspotDetail => {
            const hotspotDetailsId = hotspotDetail.getAttribute('data-hotspot-details-id')
            if (hotspotPinId == hotspotDetailsId){
                hotspotDetail.classList.add("open")
            }else{
                hotspotDetail.classList.remove("open")
            }
        })   
        })
    })

    // TO TRIGGER THE SPRING ANIMATION
    function isInViewport(element, topMargin = 0, bottomMargin = 0) {
        const rect = element.getBoundingClientRect();
        const top = rect.top - topMargin;
        const bottom = rect.bottom + bottomMargin;
    
        return (
        top >= 0 &&
        bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left >= 0 &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    let scroll = 0;
    window.addEventListener("scroll", function(){
        const topMargin = 20;
        const bottomMargin = 0;
        scroll += 1;
        const targetElement = document.querySelector('.product-hotspot-section__media-inner-wrapper');
        const observeElement = document.querySelector('.product-hotspot-section__hotspot-details-inner-wrapper');
        if (isInViewport(observeElement , topMargin, bottomMargin)) {
            if (targetElement && !targetElement.classList.contains('spring')) {
            targetElement.classList.add('spring');
            }
        } else {
            if (targetElement.classList.contains('spring')) {
            if (scroll > 60){
                targetElement.classList.remove('spring');
            scroll = 0
            }
            }
        }    
    })

    // UPDATES THE PADDING BOTTOM IF THE DETAILS ELEMENT IS OUT OF ITS CONTAINER
    function sectionMarginBottom(){
        const pdpHotspotSectionHeight = hotspotWrapperEl.getBoundingClientRect().bottom
        const hotspotDetailsElHeight = hotspotDetailsElList[0].getBoundingClientRect().bottom
        const heightDiff = hotspotDetailsElHeight - pdpHotspotSectionHeight + 12
        if (heightDiff > 0 && window.innerWidth > 768){
            hotspotWrapperEl.style.paddingBottom = `${heightDiff}px`;
        }
    }
    sectionMarginBottom()
    window.addEventListener('resize', sectionMarginBottom)
}
